// AOR pricing tiers based on company size
export const AOR_TIERS = {
  startup: [
    {
      name: 'Starter',
      price: 7500,
      description: 'Perfect for startups and small teams who need consistent design and development support.',
      features: ['Up to 30 hours/month', 'Webflow updates & new pages', 'Graphic design requests', 'Monthly strategy call', '72-hour response time'],
      featured: false,
    },
    {
      name: 'Growth',
      price: 12500,
      description: 'For growing teams ready to scale their digital presence with dedicated support.',
      features: ['Up to 50 hours/month', 'Everything in Starter', 'Brand refresh support', 'Bi-weekly strategy calls', '48-hour response time'],
      featured: true,
      popularLabel: 'Best Value',
    },
    {
      name: 'Scale',
      price: 17500,
      description: 'Full creative partnership for ambitious teams with bigger goals.',
      features: ['Up to 70 hours/month', 'Everything in Growth', 'Paid media planning', 'Weekly strategy calls', '24-hour response time'],
      featured: false,
    },
  ],
  midmarket: [
    {
      name: 'Growth',
      price: 20000,
      description: 'Perfect for growing teams who need consistent design and development support.',
      features: ['Up to 60 hours/month', 'Webflow updates & new pages', 'Graphic design requests', 'Monthly strategy call', '48-hour response time'],
      featured: false,
    },
    {
      name: 'Scale',
      price: 32500,
      description: 'For established teams needing a full creative partner with priority support.',
      features: ['Up to 100 hours/month', 'Everything in Growth', 'Brand strategy guidance', 'Paid media planning', 'Weekly strategy calls', '24-hour response time'],
      featured: true,
      popularLabel: 'Most Popular',
    },
    {
      name: 'Enterprise',
      price: null,
      description: 'Tailored solutions for organizations with complex needs.',
      features: ['Unlimited hours', 'Everything in Scale', 'Dedicated team members', 'Custom integrations', 'Multi-brand support', 'SLA guarantees'],
      featured: false,
    },
  ],
  enterprise: [
    {
      name: 'Scale',
      price: 35000,
      description: 'Full creative partnership for enterprise teams.',
      features: ['Up to 100 hours/month', 'Webflow updates & new pages', 'Brand strategy guidance', 'Paid media planning', 'Weekly strategy calls', '24-hour response time'],
      featured: true,
      popularLabel: 'Recommended',
    },
    {
      name: 'Enterprise',
      price: 55000,
      description: 'Comprehensive support with dedicated team resources.',
      features: ['Up to 180 hours/month', 'Everything in Scale', 'Dedicated team members', 'Custom integrations', 'Multi-brand support', 'Priority SLA'],
      featured: false,
    },
    {
      name: 'Custom',
      price: null,
      description: 'Tailored solutions for complex enterprise needs.',
      features: ['Unlimited hours', 'Everything in Enterprise', 'Multiple dedicated teams', 'Global support coverage', 'Executive reporting', 'Custom contracts'],
      featured: false,
    },
  ],
  largeEnterprise: [
    {
      name: 'Scale',
      price: 45000,
      description: 'Comprehensive support for large enterprise digital teams.',
      features: ['Up to 120 hours/month', 'Webflow updates & new pages', 'Brand strategy guidance', 'Paid media planning', 'Weekly strategy calls', '24-hour response time'],
      featured: false,
    },
    {
      name: 'Enterprise',
      price: 75000,
      description: 'Full creative department replacement with dedicated resources.',
      features: ['Up to 200 hours/month', 'Everything in Scale', 'Dedicated team members', 'Custom integrations', 'Multi-brand support', 'Priority SLA guarantees'],
      featured: true,
      popularLabel: 'Recommended',
    },
    {
      name: 'Custom',
      price: null,
      description: 'Fully customized solutions for the largest organizations.',
      features: ['Unlimited hours', 'Everything in Enterprise', 'Multiple dedicated teams', 'Global support coverage', 'Executive reporting', 'Custom contracts'],
      featured: false,
    },
  ],
};
